import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, Row, Col } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import '../profile.scss';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { translate } from 'react-jhipster';
import AlertMessage from 'app/view-common/AlertMessage';

export interface IModalSelectInfoProps extends StateProps, DispatchProps {
  showModal: boolean;
  type: string;
  handleConfirm: Function;
  handleClose: Function;
  handleSelectInfo: Function;

  arrProvince: any;
  arrDistrict: any;
  arrCommune: any;

  valueProvince: any;
  valueDistrict: any;
  valueCommune: any;
  valueAddress: any;
}

export interface IModalSelectInfoState {
  displayAlert: boolean;
  messageAlert: string;
}

const PROVINCE = 'province';
const DISTRICT = 'district';

class ModalSelectInfo extends React.Component<IModalSelectInfoProps, IModalSelectInfoState> {
  constructor(props) {
    super(props);
  }

  state: IModalSelectInfoState = {
    displayAlert: false,
    messageAlert: ''
  };

  handleSelectProvince = (event, type) => {
    this.props.handleSelectInfo(event.nativeEvent.target.value, type);
  };

  handleValidSubmit = (event, value) => {
    var idProvince = value.province;
    var idDistrict = value.district;
    var idCommune = value.commune;
    let arrProvinceTemp = this.props.arrProvince.filter(function(item) {
      return item.id == idProvince;
    });
    let arrDistrictTemp = this.props.arrDistrict.filter(function(item) {
      return item.id == idDistrict;
    });
    let arrCommuneTemp = this.props.arrCommune.filter(function(item) {
      return item.id == idCommune;
    });

    if (
      value.province == '' ||
      arrProvinceTemp[0].id == '-1' ||
      value.district == '' ||
      arrDistrictTemp[0] == undefined ||
      arrDistrictTemp[0].id == '-1' ||
      value.commune == '' ||
      arrCommuneTemp[0] == undefined ||
      arrCommuneTemp[0].id == '-1'
    ) {
      this.setState({
        displayAlert: true,
        messageAlert: 'Vui lòng chọn đầy đủ thông tin!'
      });
      return;
    }
    let dict = {
      province: arrProvinceTemp.length > 0 ? (arrProvinceTemp[0].id != '-1' ? arrProvinceTemp[0].name : '') : '',
      district: arrDistrictTemp.length > 0 ? (arrDistrictTemp[0].id != '-1' ? arrDistrictTemp[0].name : '') : '',
      guild: arrCommuneTemp.length > 0 ? (arrCommuneTemp[0].id != '-1' ? arrCommuneTemp[0].name : '') : '',
      addressHome: value['address'].trim().length > 0 ? value['address'].trim() : ''
    };
    this.props.handleConfirm(dict, this.props.type);
  };
  closeAlert = () => {
    this.setState({
      displayAlert: false,
      messageAlert: ''
    });
  };
  render() {
    return (
      <div>
        <AlertMessage showModal={this.state.displayAlert} message={this.state.messageAlert} closeAlert={this.closeAlert} />
        <Modal
          isOpen={this.props.showModal}
          centered={window.location === window.parent.location}
          style={{ maxWidth: window.innerWidth < 768 ? '100%' : '80%' }}
        >
          <ModalHeader toggle={this.props.handleClose}>Thông tin</ModalHeader>
          <ModalBody>
            <AvForm onValidSubmit={this.handleValidSubmit}>
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <AvField
                    name="province"
                    label="Tỉnh/Thành phố"
                    type="select"
                    value={this.props.valueProvince}
                    onChange={e => this.handleSelectProvince(e, PROVINCE)}
                  >
                    {this.props.arrProvince
                      ? this.props.arrProvince.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))
                      : null}
                  </AvField>
                </div>
                <div className="col-md-6 col-sm-12">
                  <AvField
                    name="district"
                    label="Quận/Huyện"
                    type="select"
                    value={this.props.valueDistrict}
                    onChange={e => this.handleSelectProvince(e, DISTRICT)}
                  >
                    {this.props.arrDistrict
                      ? this.props.arrDistrict.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))
                      : null}
                  </AvField>
                </div>
                <div className="col-md-6 col-sm-12">
                  <AvField name="commune" label="Phường/Xã" type="select" value={this.props.valueCommune}>
                    {this.props.arrCommune
                      ? this.props.arrCommune.map(item => (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        ))
                      : null}
                  </AvField>
                </div>
                <div className="col-md-6 col-sm-12">
                  <AvField
                    name="address"
                    label="Số nhà, đường"
                    type="text"
                    value={this.props.valueAddress}
                    validate={{
                      maxLength: { value: 100, errorMessage: translate('global.adressDetail.addressHome.maxLength') }
                    }}
                  />
                </div>
              </div>
              <Button className="btn-register" type="submit" block>
                Xác nhận
              </Button>
            </AvForm>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({});

const mapDispatchToProps = {};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalSelectInfo);
